/* HEIC-Fix 15.10.2026: iPhone-HEIC/HEIF im Browser nach JPG wandeln, sonst leere Kachel (Chrome kann HEIC nicht). */
window.apHeicFix = window.apHeicFix || function(file){
  var isH = /heic|heif/i.test(file.type||'') || /\.(heic|heif)$/i.test(file.name||'');
  if(!isH) return Promise.resolve(file);
  function lib(){
    if(window.heic2any) return Promise.resolve();
    return new Promise(function(res,rej){ var s=document.createElement('script');
      s.src='https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js'; s.onload=res; s.onerror=rej; document.head.appendChild(s); });
  }
  return lib().then(function(){ return window.heic2any({blob:file, toType:'image/jpeg', quality:0.92}); })
    .then(function(b){ if(Array.isArray(b)) b=b[0];
      return new File([b], (file.name||'foto').replace(/\.(heic|heif)$/i,'')+'.jpg', {type:'image/jpeg'}); })
    .catch(function(){
      var en=(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en';
      alert(en?'This photo is in HEIC format and could not be converted. Please share it from your gallery as JPG.':'Dieses Foto ist im HEIC-Format und konnte nicht umgewandelt werden. Bitte aus der Galerie als JPG teilen.');
      return null; });
};
(function(){
  var w=document.getElementById('vnWrap'),o=document.getElementById('vnOv'),l=document.getElementById('vnLine');
  if(!w)return;
  var drag=false;
  function setW(){if(w)w.style.setProperty('--vn-w',w.offsetWidth+'px');}
  setW();window.addEventListener('resize',setW);
  function pos(x){var r=w.getBoundingClientRect();var p=Math.max(3,Math.min(97,((x-r.left)/r.width)*100));o.style.width=p+'%';l.style.left=p+'%';}
  w.addEventListener('mousedown',function(e){drag=true;pos(e.clientX);e.preventDefault();});
  document.addEventListener('mousemove',function(e){if(drag)pos(e.clientX);});
  document.addEventListener('mouseup',function(){drag=false;});
  w.addEventListener('touchstart',function(e){drag=true;pos(e.touches[0].clientX);},{passive:true});
  document.addEventListener('touchmove',function(e){if(drag)pos(e.touches[0].clientX);},{passive:true});
  document.addEventListener('touchend',function(){drag=false;});
})();
window.ahVn=function(btn,name,url){
  document.querySelectorAll('#ah .vn-btn').forEach(function(b){b.classList.remove('on');});
  btn.classList.add('on');
  var ov=document.getElementById('vnAfterImg');
  var t=document.getElementById('vnTag');
  if(ov){ov.style.transition='opacity .3s';ov.style.opacity='0';setTimeout(function(){ov.src=url;ov.style.opacity='1';},200);}
  if(t)t.textContent=name;
  var info=document.getElementById('stilInfo');
  if(info){
    info.style.opacity='0';
    setTimeout(function(){
      var n=document.getElementById('stilNum');
      var tg=document.getElementById('stilTag');
      var nm=document.getElementById('stilName');
      var ds=document.getElementById('stilDesc');
      if(n)n.textContent=btn.dataset.num||'';
      if(tg)tg.textContent=btn.dataset.tag||'';
      if(nm)nm.textContent=name;
      if(ds)ds.textContent=btn.dataset.desc||'';
      info.style.opacity='1';
    },200);
  }
};

/* ── FRAME-SLIDER (v38) ── */
(function(){
  var w=document.getElementById('fsWrap'),o=document.getElementById('fsOv'),l=document.getElementById('fsLine');
  if(!w)return;
  var drag=false;
  function setW(){if(w)w.style.setProperty('--fs-w',w.offsetWidth+'px');}
  setW();window.addEventListener('resize',setW);
  function pos(x){var r=w.getBoundingClientRect();var p=Math.max(3,Math.min(97,((x-r.left)/r.width)*100));o.style.width=p+'%';l.style.left=p+'%';}
  w.addEventListener('mousedown',function(e){drag=true;pos(e.clientX);e.preventDefault();});
  document.addEventListener('mousemove',function(e){if(drag)pos(e.clientX);});
  document.addEventListener('mouseup',function(){drag=false;});
  w.addEventListener('touchstart',function(e){drag=true;pos(e.touches[0].clientX);},{passive:true});
  document.addEventListener('touchmove',function(e){if(drag)pos(e.touches[0].clientX);},{passive:true});
  document.addEventListener('touchend',function(){drag=false;});
})();
/* ── STIL-DIAL (v41) ── */
(function(){
  var track=document.getElementById('fsDial');
  if(!track)return;
  var items=[].slice.call(track.querySelectorAll('.fs-dial-item'));
  var cur=0,st,lock=0;
  function apply(i,scrollTo){
    if(i<0||i>=items.length)return;
    var it=items[i];
    if(scrollTo){
      lock=Date.now()+800;
      var tr=track.getBoundingClientRect(),ir=it.getBoundingClientRect();
      var vert=getComputedStyle(track).flexDirection==='column';
      if(vert)track.scrollTo({top:track.scrollTop+(ir.top+ir.height/2)-(tr.top+tr.height/2),behavior:'smooth'});
      else track.scrollTo({left:track.scrollLeft+(ir.left+ir.width/2)-(tr.left+tr.width/2),behavior:'smooth'});
    }
    if(i===cur)return;
    cur=i;
    items.forEach(function(b,k){b.classList.toggle('on',k===i);});
    var ov=document.getElementById('fsAfterImg');
    var t=document.getElementById('fsTag');
    if(ov && it.dataset.url){ov.style.transition='opacity .3s';ov.style.opacity='0';setTimeout(function(){ov.src=it.dataset.url;ov.style.opacity='1';},200);}
    if(t)t.textContent=it.textContent;var tm=document.getElementById('fsTagM');if(tm)tm.textContent=it.textContent;
    var info=document.getElementById('fsInfo');
    if(info){
      info.style.opacity='0';
      setTimeout(function(){
        document.getElementById('fsNum').textContent=it.dataset.num||'';
        document.getElementById('fsInfoTag').textContent=it.dataset.tag||'';
        document.getElementById('fsName').textContent=it.textContent;
        document.getElementById('fsDesc').textContent=it.dataset.desc||'';
        info.style.opacity='1';
      },200);
    }
  }
  function nearest(){
    var r=track.getBoundingClientRect(),cx=r.left+r.width/2,cy=r.top+r.height/2,best=0,bd=1e9;
    items.forEach(function(b,i){var br=b.getBoundingClientRect();var dx=br.left+br.width/2-cx,dy=br.top+br.height/2-cy;var d=dx*dx+dy*dy;if(d<bd){bd=d;best=i;}});
    return best;
  }
  track.addEventListener('scroll',function(){
    clearTimeout(st);st=setTimeout(function(){if(Date.now()<lock)return;apply(nearest(),false);},120);
  },{passive:true});
  items.forEach(function(b,i){b.addEventListener('click',function(){apply(i,true);});});
  var p=document.getElementById('fsPrev'),n=document.getElementById('fsNext');
  if(p)p.addEventListener('click',function(){apply(Math.max(0,cur-1),true);});
  if(n)n.addEventListener('click',function(){apply(Math.min(items.length-1,cur+1),true);});
  lock=Date.now()+800;
  requestAnimationFrame(function(){
    var tr=track.getBoundingClientRect(),ir=items[0].getBoundingClientRect();
    if(getComputedStyle(track).flexDirection==='column')track.scrollTop+=(ir.top+ir.height/2)-(tr.top+tr.height/2);
    else track.scrollLeft+=(ir.left+ir.width/2)-(tr.left+tr.width/2);
  });
})();

/* Lazy-Load Erklaervideo: erst laden + abspielen wenn sichtbar (schont Ladezeit) */
(function(){
  var vids=document.querySelectorAll('#ah .steps-video-el');
  if(!vids.length)return;
  function activate(v){
    var src=v.querySelector('source');
    if(src && src.getAttribute('data-src') && !src.src){
      src.src=src.getAttribute('data-src'); v.load();
      var p=v.play(); if(p&&p.catch)p.catch(function(){});
    }
  }
  vids.forEach(function(v){
    v.addEventListener('playing',function(){
      var ph=v.parentNode.querySelector('.steps-video-ph');
      if(ph)ph.style.display='none';
    });
  });
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ activate(e.target); io.unobserve(e.target); } });
    },{rootMargin:'200px'});
    vids.forEach(function(v){io.observe(v);});
  } else { vids.forEach(activate); }
})();

/* ---- Kategorie-Scroll (war Block B) ---- */
window.apKatScroll = function(dir){
  var el = document.querySelector('.kat-inner');
  if(!el) return;
  var amt = Math.min(el.clientWidth * 0.7, 420);
  el.scrollBy({left: dir * amt, behavior: 'smooth'});
};

/* ---- Hero-Dropzone + Handoff (war Block C) ---- */
/* ── HERO-DROPZONE → Foto komprimieren, in Handoff-Speicher, weiter zur Produktseite ── */
(function(){
  var drop=document.getElementById('heroDrop');
  var fileInput=document.getElementById('heroFile');
  var btn=document.getElementById('heroDropBtn');
  if(!drop||!fileInput)return;
  var PRODUCT_URL=(/^us\./i.test(location.hostname))?'/products/your-artwork-canvas':(((location.pathname.match(/^\/en(?=\/|$)/i)||[''])[0])+'/products/dein-kunstwerk-leinwand'); /* AP-MARKT-LINK-3110: Markt = Domain, nicht Sprache */
  var HKEY='arturell_handoff_v1';
  /* ── WEITER-BEARBEITEN: hat der Kunde schon Werke (arturell_werke_v1)? ── */
  (function(){
    try{
      var WKEY='arturell_werke_v1';           /* == AP_WERKE_KEY der Produktseite */
      var TTL=14*24*60*60*1000;                /* 14 Tage, wie Produktseite */
      var raw=localStorage.getItem(WKEY);
      if(!raw)return;
      var data=JSON.parse(raw);
      if(!data||!data.items||!data.items.length)return;
      if(Date.now()-(data.ts||0)>TTL)return;
      var n=data.items.length;
      var wrap=document.getElementById('heroWeiter');
      var txt=document.getElementById('heroWeiterTxt');
      if(!wrap)return;
      if(txt)txt.textContent=(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?('Continue your '+n+' '+(n===1?'preview':'artworks')):('Deine '+n+' '+(n===1?'Vorschau':'Werke')+' weiter bearbeiten');
      wrap.style.display='flex';
    }catch(e){}
  })();

  (function(){
    try{
      var raw=localStorage.getItem('arturell_familie_v1');
      if(!raw)return;
      var data=JSON.parse(raw);
      var hat=(data&&data.items&&data.items.length)||(data&&data.familyMergedUrl);
      if(!hat)return;
      if(Date.now()-(data.ts||0)>14*24*60*60*1000)return;
      var wrap=document.getElementById('heroWeiterFam');
      var txt=document.getElementById('heroWeiterFamTxt');
      if(!wrap)return;
      var n=(data.items||[]).length;
      if(txt&&n)txt.textContent=(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?('Continue your '+n+' family '+(n===1?'preview':'artworks')):('Deine '+n+' Familien-'+(n===1?'Vorschau':'Werke')+' weiter bearbeiten');
      wrap.style.display='flex';
    }catch(e){}
  })();
  drop.addEventListener('click',function(e){ if(e && e.target===fileInput) return; fileInput.click(); });
  if(btn)btn.addEventListener('click',function(e){ e.stopPropagation(); fileInput.click(); });
  ['dragenter','dragover'].forEach(function(ev){drop.addEventListener(ev,function(e){e.preventDefault();drop.classList.add('drag');});});
  ['dragleave'].forEach(function(ev){drop.addEventListener(ev,function(e){e.preventDefault();drop.classList.remove('drag');});});
  drop.addEventListener('drop',function(e){e.preventDefault();drop.classList.remove('drag');var f=e.dataTransfer&&e.dataTransfer.files&&e.dataTransfer.files[0];if(f)handle(f);});
  fileInput.addEventListener('change',function(e){var f=e.target.files&&e.target.files[0];if(f)handle(f);});
  function go(){ window.location.href=PRODUCT_URL; }
  function handle(file){
    if(!/^image\//.test(file.type||'')){alert('Bitte ein Bild wählen (JPG oder PNG).');return;}
    drop.classList.add('hero-busy');
    var big=drop.querySelector('.hero-drop-big'); if(big)big.textContent='Wird geladen …';
    var r=new FileReader();
    r.onload=function(ev){
      var img=new Image();
      img.onload=function(){
        var small=ev.target.result;
        try{
          var max=800,w=img.width,h=img.height;
          if(w>=h){ if(w>max){h=Math.round(h*max/w);w=max;} } else { if(h>max){w=Math.round(w*max/h);h=max;} }
          var c=document.createElement('canvas');c.width=w;c.height=h;
          c.getContext('2d').drawImage(img,0,0,w,h);
          small=c.toDataURL('image/jpeg',0.85);
        }catch(err){}
        try{ localStorage.setItem(HKEY,JSON.stringify({ts:Date.now(),foto:small})); }catch(e2){}
        go();
      };
      img.onerror=go;
      img.src=ev.target.result;
    };
    r.onerror=go;
    window.apHeicFix(file).then(function(f2){ if(!f2){ go(); return; } file=f2; r.readAsDataURL(f2); });
  }
})();
